import { createSelector } from 'reselect';
import { initialState } from './reducers';

const userState = (state) => state.user || initialState;

const selectUser = () => createSelector(userState, (state) => state.user);

const selectUserError = () => createSelector(userState, (state) => state.error);

const selectAcceptedEula = () =>
  createSelector(userState, (state) => state.user.accepted_eula);

// const makeSelectUserProfileActivityLogs = () =>
//   createSelector(userState, (state) => state.userProfileActivityLogs);

// const makeSelectUserProfileActivityLogsError = () =>
//   createSelector(userState, (state) => state.userProfileActivityLogsError);

// const makeSelectColumnsLocations = () =>
//   createSelector(userState, (state) => state.columns);
// const makeSelectColumnsActivityLogs = () =>
//   createSelector(userState, (state) => state.columnsActivityLogs);

const makeSelectIsActivityLogTab = () =>
  createSelector(userState, (state) => state.isActivityLogTab);

const makeSelectIsEditMode = () =>
  createSelector(userState, (state) => state.isEditMode);

const makeSelectShowIxoneSplashScreen = () =>
  createSelector(userState, (state) => state.showIxoneSplashScreen);

const makeSelectContactCardInfo = () =>
  createSelector(userState, (state) => state.contactCard);

const makeSelectMemberId = () =>
  createSelector(userState, (state) => state.memberId);

// const makeSelectWorkflowRoles = () =>
//   createSelector(userState, (state) => state.workflowRoles);

const makeSelectUserGDSNPartyInfo = () =>
  createSelector(userState, (state) => state.userGDSNPatyInfo);

const makeSelectMfaLoginInfo = () =>
  createSelector(userState, (state) => state.mfaLoginInfo);

const makeSelectUnlockAccountInfo = () =>
  createSelector(userState, (state) => state.unlockAccountInfo);

const userSelecters = {
  selectUser,
  selectUserError,
  selectAcceptedEula,
  // makeSelectColumnsLocations,
  // makeSelectColumnsActivityLogs,
  // makeSelectUserProfileActivityLogs,
  // makeSelectUserProfileActivityLogsError,
  makeSelectIsActivityLogTab,
  makeSelectIsEditMode,
  makeSelectShowIxoneSplashScreen,
  makeSelectContactCardInfo,
  makeSelectMemberId,
  // makeSelectWorkflowRoles,
  makeSelectUserGDSNPartyInfo,
  makeSelectMfaLoginInfo,
  makeSelectUnlockAccountInfo,
};

export default userSelecters;
